import StyledTable, { Align } from "../../../StyledTable/StyledTable";
import { useEffect, useState } from "react";
import classNames from "classnames/bind";
import styles from "./HoldingPortfolio.module.scss";
import { Stack, useTheme } from "@mui/system";
import { getAllocPortfolios } from "@/controllers/gridManager/followerTransManager/followerTransManager";
import ViewNumberFormat from "@/views/elements/Inputs/ViewNumberFormat";
import TypographyElement from "@/views/elements/typography/TypographyElement";
import { useCosInfo } from "@/controllers/gridManager/accountsManager/accountManager";
import { getAvlBuyPoint } from "@/controllers/gridManager/masterTransManager/masterTransManager";
import { useTranslation } from "react-i18next";
import CommonUtils from "@/utilities/utils";

const cx = classNames.bind(styles);

type HoldingPortfolioProps = {
  accountId?: string;
  masterCustodycd?: string;
}

const HoldingPortfolio = ({ accountId, masterCustodycd }: HoldingPortfolioProps) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const [tableData, setTableData] = useState<any>(null);
  const [isRecommend, setIsRecommend] = useState(false);
  const { cosInfo } = useCosInfo()

  useEffect(() => {
    loadData()
    loadAvlBuyPoint()
  }, [])

  const loadData = async () => {
    let response = await getAllocPortfolios(
      accountId || cosInfo.refaccount,
      masterCustodycd || '')
    if (response.isSuccess) {
      setTableData(response.data)
    }
  }

  const loadAvlBuyPoint = async () => {
    let response = await getAvlBuyPoint(accountId || cosInfo.refaccount)
    if (response.isSuccess) {
      setIsRecommend(response.data.avlbuypoint === 'Y' ? true : false)
    }
  }

  const cookedData = () => {
    return (
      tableData?.map(
        (portfolio: {
          symbol: string;
          pnlrate: number;
          marketprice: number;
          costprice: number;
          assetrate: number;
        }) => portfolio.symbol === 'Tiền' ? {
          symbol: portfolio.symbol,
          costprice: '',
          marketPrice: '',
          dm: CommonUtils.formatNumber(portfolio.assetrate * 100),
          pnlrate: ''
        } : {
            symbol: portfolio.symbol,
            costprice: CommonUtils.formatNumber(portfolio.costprice),
            marketPrice: CommonUtils.formatNumber(portfolio.marketprice),
            dm: CommonUtils.formatNumber(portfolio.assetrate * 100),
            pnlrate: CommonUtils.formatNumber(portfolio.pnlrate) + '%'
          }
      ) || []
    );
  };

  const tableConfig = {
    fields: [
      { valueName: "symbol", name: t('copytrade.common.symbol'), width: 90 },
      { valueName: "costprice", name: t('copytrade.chart.holdingPortfolio.costprice'), width: 150, align: Align.right, render: (value: any) => <ViewNumberFormat displayType="text" value={value} /> },
      { valueName: "marketPrice", name: t('copytrade.chart.holdingPortfolio.marketPrice'), width: 110, align: Align.right, render: (value: any) => <ViewNumberFormat displayType="text" value={value} /> },
      { valueName: "dm", name: t('copytrade.chart.holdingPortfolio.dm'), width: 160, align: Align.right, render: (value: any) => <TypographyElement width='fit-content'>{value}%</TypographyElement> },
      { valueName: "pnlrate", name: t('copytrade.chart.holdingPortfolio.pnlrate'), width: 160, align: Align.right, render: (value: any) => <TypographyElement width='fit-content' ColorElement={!value.includes('-') ? 'up' : 'down'}>{value}</TypographyElement> },
    ],
    pagination: {
      enabled: false,
    },
    header: {
      styles: {
        backgroundColor: "transparent",
      },
    },
  };

  return (
      <Stack p='20px' spacing='15px' direction='column' className={cx("holding-portfolio")}>
        <Stack className={cx("holding-portfolio__header")} direction='row'>
          <TypographyElement FontWeightElement={700} FontSizeElement='16px' lineHeight='24px'>{t('copytrade.chart.holdingPortfolio.title')}</TypographyElement>
          {isRecommend && <TypographyElement ColorElement="brand" FontSizeElement="12px" className={cx("holding-portfolio__newbuy")}>{t('copytrade.chart.holdingPortfolio.newbuy')}</TypographyElement>}
        </Stack>
        <StyledTable
          sx={{
            flex: 1,
            "& th": {
              backgroundColor: theme.palette.background.default
            }
          }}
          tableConfig={tableConfig}
          tableData={cookedData()}
          onPageChange={loadData}
          onLimitChange={loadData}
          onRowClick={() => {}}
        />
      </Stack>
  );
};

export default HoldingPortfolio;
